import { render, staticRenderFns } from "./Cont_bottom.vue?vue&type=template&id=7f60021c&scoped=true"
import script from "./Cont_bottom.vue?vue&type=script&lang=js"
export * from "./Cont_bottom.vue?vue&type=script&lang=js"
import style0 from "./Cont_bottom.vue?vue&type=style&index=0&id=7f60021c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60021c",
  null
  
)

export default component.exports